interface Props {
  label: string;
  value: string | number;
  subtitle?: string;
  subtitleColor?: string;
  icon?: React.ReactNode;
  accentClass?: string;
  variant?: "default" | "hero";
}

export function KpiCard({ label, value, subtitle, subtitleColor = "text-muted-foreground", icon, accentClass = "border-l-brand", variant = "default" }: Props) {
  if (variant === "hero") {
    return (
      <div className="bg-gradient-to-br from-[#1d3f26] to-[#2c6a34] p-5 rounded-2xl text-white">
        <div className="flex items-center justify-between mb-2">
          <span className="text-[11px] font-semibold text-[#a9d69a] uppercase tracking-widest">{label}</span>
          {icon && <span className="text-white/60">{icon}</span>}
        </div>
        <div className="text-3xl font-bold font-heading">{value}</div>
        {subtitle && <div className="text-xs mt-1.5 text-[#8DE05A] font-medium">{subtitle}</div>}
      </div>
    );
  }
  return (
    <div className={`bg-card p-5 rounded-2xl border border-border border-l-4 ${accentClass} hover:shadow-md transition-shadow`}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-[11px] font-semibold text-muted-foreground uppercase tracking-widest">{label}</span>
        {icon && <span className="text-muted-foreground/50">{icon}</span>}
      </div>
      <div className="text-3xl font-bold text-text font-heading">{value}</div>
      {subtitle && <div className={`text-xs mt-1.5 ${subtitleColor}`}>{subtitle}</div>}
    </div>
  );
}
